import { useEffect } from "react";
import { t, tInitialize } from "../query/share";
import { modalsType } from "./hooks/modals";
import { baseType } from "./hooks/base";
import { authAxios } from "./Types";
import { pageNames, posType } from "./hooks/pos";
import { initial } from "../query/initial";
import PlanSingle from "./plans/Single";
import { useAppBridge } from "@shopify/app-bridge-react";

const Initial = (
  props: modalsType & baseType & authAxios & posType & modalsType,
) => {
  const { changeBase, changePos, changeModals } = props;
  const shopify = useAppBridge();
  useEffect(() => {
    const getInfor = async () =>
      await initial().then((data): void => {
        if (!data.result) {
          if (data.reason === "noPayment") {
            //@ts-ignore
            const { locale } = shopify.config;
            tInitialize(locale.includes("ja") ? "ja" : "en");
            changeModals({
              open: true,
              children: <PlanSingle {...props} planName="normal" />,
              title: t("料金の支払いへ", "Proceed payments"),
              notClose: true,
            });
          }
        } else {
          if (data.base) {
            changeBase({ ...data.base });
            tInitialize(data.base.lang || "en");
          }
        }
      });
    getInfor().then((r) => {
      changePos({ page: pageNames.top });
    });
  }, []);

  return <></>;
};

export default Initial;
